// extracted by mini-css-extract-plugin
export default {"brandPromo":"zH-z","carousel":"AH-z"};